import { EuropeanUnionList } from '../../constants/quote';
import { PartnerType, PromotionEntityType, SubBrokerType } from '../../shared/generated';
export var getLandingPageBrokerName = function getLandingPageBrokerName(promotionInfo) {
  var name = '';

  if ((promotionInfo === null || promotionInfo === void 0 ? void 0 : promotionInfo.promotion_type) === PromotionEntityType.BROKER_PROMOTION) {
    name = (promotionInfo === null || promotionInfo === void 0 ? void 0 : promotionInfo.brokerName) || '';
  }

  return name;
};
export var judgeIsSubBroker = function judgeIsSubBroker(data) {
  return !!(data !== null && data !== void 0 && data.parent_id);
};
export var judgeQuoteIsBrokerOrPartnerQuote = function judgeQuoteIsBrokerOrPartnerQuote(quoteDetailInfo) {
  var _quoteDetailInfo$prom;

  return [PromotionEntityType.BROKER_PROMOTION, PromotionEntityType.PARTNER_PROMOTION].includes(quoteDetailInfo === null || quoteDetailInfo === void 0 ? void 0 : (_quoteDetailInfo$prom = quoteDetailInfo.promotion) === null || _quoteDetailInfo$prom === void 0 ? void 0 : _quoteDetailInfo$prom.promotion_type);
};
export var getBrokerDefaultCommissionFee = function getBrokerDefaultCommissionFee(config) {
  return EuropeanUnionList.includes(config === null || config === void 0 ? void 0 : config.country) ? 15 : 20;
};
export var getBrokerDefaultUnderwritingFee = function getBrokerDefaultUnderwritingFee(config) {
  return 5;
};
export var judgeIsPartnerWithSourceAndSubBrokerType = function judgeIsPartnerWithSourceAndSubBrokerType(config) {
  return (config === null || config === void 0 ? void 0 : config.source) === PartnerType.GENERAL || (config === null || config === void 0 ? void 0 : config.subBrokerType) === SubBrokerType.PARTNER;
};
export var judgeIsPartnerWithPartnerTypeAndSubBrokerType = function judgeIsPartnerWithPartnerTypeAndSubBrokerType(config) {
  return (config === null || config === void 0 ? void 0 : config.partnerType) === PartnerType.GENERAL || (config === null || config === void 0 ? void 0 : config.subBrokerType) === SubBrokerType.PARTNER;
};
export var getQuoteBrokerCommissionDetailsInformationWithQuoteData = function getQuoteBrokerCommissionDetailsInformationWithQuoteData(data) {
  var _ref = data || {},
      promotionId = _ref.promotionId,
      brokerFeeChain = _ref.brokerFeeChain;

  var currentItem = brokerFeeChain === null || brokerFeeChain === void 0 ? void 0 : brokerFeeChain.find(function (item) {
    return item.promotion_id === promotionId;
  });
  var wholesaleItem = brokerFeeChain === null || brokerFeeChain === void 0 ? void 0 : brokerFeeChain[0];
  return {
    brokerCommission: currentItem === null || currentItem === void 0 ? void 0 : currentItem.broker_commission,
    brokerCommissionType: currentItem === null || currentItem === void 0 ? void 0 : currentItem.broker_commission_type,
    brokerCommissionAmount: currentItem === null || currentItem === void 0 ? void 0 : currentItem.broker_commission_amount,
    brokerCommissionDiscount: currentItem === null || currentItem === void 0 ? void 0 : currentItem.broker_commission_discount,
    brokerCommissionDiscountType: currentItem === null || currentItem === void 0 ? void 0 : currentItem.broker_commission_discount_type,
    brokerCommissionDiscountAmount: currentItem === null || currentItem === void 0 ? void 0 : currentItem.broker_commission_discount_amount,
    brokerFee: currentItem === null || currentItem === void 0 ? void 0 : currentItem.broker_fee,
    brokerFeeType: currentItem === null || currentItem === void 0 ? void 0 : currentItem.broker_fee_type,
    brokerFeeAmount: currentItem === null || currentItem === void 0 ? void 0 : currentItem.broker_fee_amount,
    wholesaleBrokerCommission: wholesaleItem === null || wholesaleItem === void 0 ? void 0 : wholesaleItem.broker_commission,
    wholesaleBrokerCommissionType: wholesaleItem === null || wholesaleItem === void 0 ? void 0 : wholesaleItem.broker_commission_type,
    wholesaleBrokerCommissionAmount: wholesaleItem === null || wholesaleItem === void 0 ? void 0 : wholesaleItem.broker_commission_amount,
    wholesaleBrokerCommissionDiscount: wholesaleItem === null || wholesaleItem === void 0 ? void 0 : wholesaleItem.broker_commission_discount,
    wholesaleBrokerCommissionDiscountType: wholesaleItem === null || wholesaleItem === void 0 ? void 0 : wholesaleItem.broker_commission_discount_type,
    wholesaleBrokerCommissionDiscountAmount: wholesaleItem === null || wholesaleItem === void 0 ? void 0 : wholesaleItem.broker_commission_discount_amount,
    wholesaleBrokerFee: wholesaleItem === null || wholesaleItem === void 0 ? void 0 : wholesaleItem.broker_fee,
    wholesaleBrokerFeeType: wholesaleItem === null || wholesaleItem === void 0 ? void 0 : wholesaleItem.broker_fee_type,
    wholesaleBrokerFeeAmount: wholesaleItem === null || wholesaleItem === void 0 ? void 0 : wholesaleItem.broker_fee_amount
  };
};